import { Component, Input, OnInit } from "@angular/core";
import { FormControl, ValidatorFn, Validators } from "@angular/forms";

@Component({
    selector: 'radio-group',
    templateUrl: './radio-group.component.html',
    styleUrls: ['./radio-group.component.scss'],
    standalone: false
})
export class RadioGroupComponent {
    @Input() control: FormControl = new FormControl();
    @Input() label = '';
    @Input() options!: any[];
    requiredValidator: ValidatorFn = Validators.required;
}